import { callBackendFunction } from "./paymentService";

export interface ExportOutingReportParams {
  outingId: string;
  format?: "xlsx";
}

export interface ExportOutingReportResponse {
  success: boolean;
  filename: string;
  mimeType: string;
  base64: string;
}

export async function exportOutingReport(params: ExportOutingReportParams) {
  return callBackendFunction<ExportOutingReportParams, ExportOutingReportResponse>(
    "exportOutingReport",
    params,
  );
}

export async function downloadOutingReportAsXlsx(outingId: string) {
  if (!outingId) {
    throw new Error("Identifiant de sortie manquant pour l’export Excel.");
  }

  let objectUrl: string | null = null;
  const anchor = document.createElement("a");

  try {
    const result = await exportOutingReport({ outingId, format: "xlsx" });

    if (!result?.success || !result?.base64) {
      throw new Error("Le backend n’a pas retourné de fichier Excel exploitable.");
    }

    const binaryString = window.atob(result.base64);
    const bytes = new Uint8Array(binaryString.length);

    for (let index = 0; index < binaryString.length; index += 1) {
      bytes[index] = binaryString.charCodeAt(index);
    }

    const blob = new Blob([bytes], {
      type: result.mimeType || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    objectUrl = window.URL.createObjectURL(blob);
    anchor.href = objectUrl;
    anchor.download = result.filename || `rapport-sortie-${outingId}.xlsx`;
    document.body.appendChild(anchor);
    anchor.click();

    return result;
  } catch (error: any) {
    const baseMessage = error?.message || "Erreur inconnue côté export.";
    throw new Error(`Impossible de générer le rapport Excel : ${baseMessage}`);
  } finally {
    anchor.remove();
    if (objectUrl) {
      window.setTimeout(() => window.URL.revokeObjectURL(objectUrl as string), 1000);
    }
  }
}
